import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { DataPersistence, fetch } from '@nrwl/angular';
import { HttpClient } from '@angular/common/http';
import { JobCardPartialState } from './job-card.reducer';
import {
  LoadJobCard,
  JobCardLoaded,
  JobCardLoadError,
  JobCardActionTypes,
  LoadSelectedJobCard,
  SelectedJobCardLoaded,
  SelectedJobCardLoadError,
  CreateJobCard,
  JobCardCreated,
  CreateJobCardError,
  NextJobNoUpdated,
  NextJobNoUpdatedError,
  NextJobNoLoaded,
  LoadNextJobNo,
  LoadNextJobNoError,
  UpdateJObCard,
  JobCardUpdated,
  UpdateJobCardError,
  SaveStuffingDetails,
  SaveLoadingConfirmationDetails,
  SaveTVTBLDetails,
  SaveEGLBLDetails,
  SaveAWBDetails,
  SaveACDDetails,
  UploadFiles,
  FilesUploaded,
  FileUploadError,
  LoadFiles,
  FilesLoaded,
  FilesLoadError,
  FilesProgress,
  SaveAWBDetailsError,
  LoadAWBDetails,
  AWBDetailsLoaded,
  LoadAWBDetailsError,
  UpdateAWBDetails,
  AWBDetailsUpdated,
  UpdateAWBDetailsError,
} from './job-card.actions';
import { API } from 'aws-amplify';
import * as queries from '../../../../../../apps/website/src/queries';
import * as mutations from '../../../../../../apps/website/src/mutations';
import { map } from 'rxjs/operators';
import { from } from 'rxjs';
import { GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Storage } from 'aws-amplify';
import { AuthPartialState } from '../../auth-data-access/+state/auth.reducer';

@Injectable()
export class JobCardEffects {
  @Effect() loadJobCard$ = this.actions$.pipe(
    ofType(JobCardActionTypes.LoadJobCard),
    fetch({
      run: (action: LoadJobCard, state: JobCardPartialState) => {
        let nextToken: string;
        let filter;
        if (action.filter) {
          filter = {
            or: [
              {
                shipperName: {
                  contains: action.filter,
                },
              },
              {
                shippingBillNo: {
                  contains: action.filter,
                },
              },
              {
                jobNo: {
                  contains: action.filter,
                },
              },
            ],
          };
        } else if (action.filterByMode) {
          if (action.filterByMode === 'AIR') {
            filter = {
              mode: {
                contains: 'AIR',
              },
            };
          } else if (action.filterByMode === 'SEA') {
            filter = {
              or: [
                {
                  mode: {
                    contains: 'FCL',
                  },
                },
                {
                  mode: {
                    contains: 'LCL',
                  },
                },
              ],
            };
          }
        }
        //if (action.filter) {
        return from(
          API.graphql({
            query: queries.jobCardByDate,
            variables: { filter: filter },
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          })
        ).pipe(
          map((data: { data }) => {
            //nextToken = data.data.listJobCards.nextToken;
            return new JobCardLoaded(data.data.listJobCards.items);
          })
        );
        // } else {
        //   return from(
        //     API.graphql({
        //       query: queries.listJobCards,
        //       authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        //     })
        //   ).pipe(
        //     map((data: { data }) => {
        //       //nextToken = data.data.listJobCards.nextToken;
        //       return new JobCardLoaded(data.data.listJobCards.items);
        //     })
        //   );
        // }
      },

      onError: (action: LoadJobCard, error) => {
        console.error('Error', error);
        return new JobCardLoadError(error);
      },
    })
  );
  @Effect() loadSelectedJobCard$ = this.actions$.pipe(
    ofType(JobCardActionTypes.LoadSelectedJobCard),
    fetch({
      run: (action: LoadSelectedJobCard, state: JobCardPartialState) => {
        return from(
          API.graphql({
            query: queries.getJobCard,
            variables: {
              id: action.payload,
            },
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          })
        ).pipe(
          map((data: { data }) => {
            return new SelectedJobCardLoaded(data.data.getJobCard);
          })
        );
      },
      onError: (action: LoadSelectedJobCard, error) => {
        return new SelectedJobCardLoadError(error);
      },
    })
  );
  @Effect() createJobCard$ = this.dataPersistence.pessimisticUpdate(
    JobCardActionTypes.CreateJobCard,
    {
      run: (action: CreateJobCard, state) => {
        const {
          auth: {
            user: {
              idToken: {
                payload: { email },
              },
            },
          },
        } = state;

        let jobType: string;
        if (action.payload.mode === 'AIR') {
          jobType = 'air';
        } else {
          jobType = 'sea';
        }
        let formInputs = {
          ...action.payload,
          status: 'Open',
          type: jobType,
          editable: true,
          ownerEmail: email,
        };

        return from(
          API.graphql({
            query: mutations.createJobCard,
            variables: { input: formInputs },
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          })
        ).pipe(
          map((data: { data: any }) => {
            this.router.navigate(['employee/jobs-list']);
            this._snackBar.open('Job Created Successfully', null, {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: 'custom-snackbar-success',
            });
            return new JobCardCreated(data.data.createJobCard);
          })
        );
      },
      onError: (action: CreateJobCard, error) => {
        this._snackBar.open(error.errors[0].message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new CreateJobCardError(error);
      },
    }
  );

  @Effect() loadNextJobNo$ = this.actions$.pipe(
    ofType(JobCardActionTypes.LoadNextJobNo),
    fetch({
      run: (action: LoadNextJobNo, state: JobCardPartialState) => {
        return from(
          API.graphql({
            query: queries.listNextJobNos,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          })
        ).pipe(
          map((data: { data }) => {
            return new NextJobNoLoaded(data.data.listNextJobNos.items[0]);
          })
        );
      },
      onError: (action: LoadNextJobNo, error) => {
        return new LoadNextJobNoError(error);
      },
    })
  );

  @Effect() jobCardCreated$ = this.dataPersistence.pessimisticUpdate(
    JobCardActionTypes.JobCardCreated,
    {
      run: (action: JobCardCreated, state) => {
        let { jobCard } = state;

        if (action.payload.companyName === 'The Vantage Tradelink') {
          return from(
            API.graphql({
              query: mutations.updateNextJobNo,
              variables: {
                input: {
                  id: '81120c05-26e6-43e0-ade9-8c397b58c97a',
                  nextTVTJobNo: jobCard.nextJobNo.nextTVTJobNo + 1,
                },
              },
              authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            })
          ).pipe(
            map((data: { data }) => {
              return new NextJobNoUpdated(data.data.updateNextJobNo);
            })
          );
        } else if (action.payload.companyName === 'TVT Logistics India') {
          return from(
            API.graphql({
              query: mutations.updateNextJobNo,
              variables: {
                input: {
                  id: '81120c05-26e6-43e0-ade9-8c397b58c97a',
                  nextTLIJobNo: jobCard.nextJobNo.nextTLIJobNo + 1,
                },
              },
              authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            })
          ).pipe(
            map((data: { data }) => {
              return new NextJobNoUpdated(data.data.updateNextJobNo);
            })
          );
        } else if (action.payload.companyName === 'EGL Maritime') {
          return from(
            API.graphql({
              query: mutations.updateNextJobNo,
              variables: {
                input: {
                  id: '81120c05-26e6-43e0-ade9-8c397b58c97a',
                  nextEGLJobNo: jobCard.nextJobNo.nextEGLJobNo + 1,
                },
              },
              authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            })
          ).pipe(
            map((data: { data }) => {
              return new NextJobNoUpdated(data.data.updateNextJobNo);
            })
          );
        }
      },
      onError: (action: JobCardCreated, error) => {
        this._snackBar.open(error.errors[0].message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new NextJobNoUpdatedError(error);
      },
    }
  );

  @Effect() updateJobCard$ = this.dataPersistence.pessimisticUpdate(
    JobCardActionTypes.UpdateJObCard,
    {
      run: (action: UpdateJObCard, state: AuthPartialState) => {
        const {
          auth: { user },
        } = state;
        return from(
          API.graphql({
            query: mutations.updateJobCard,
            variables: { input: action.payload },
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          })
        ).pipe(
          map((data: { data }) => {
            if (action.onTransfer) {
              if (action.email) {
                let body;
                if (action.email === 'requestForEdit') {
                  let formattedDate = data.data.updateJobCard.RequestedDate;
                  formattedDate = new Date().toString();
                  body = {
                    jobNo: data.data.updateJobCard.jobNo,
                    owner: data.data.updateJobCard.owner,
                    requestedDate: formattedDate,
                    id: data.data.updateJobCard.id,
                    type: 'requestForEdit',
                  };
                } else if (action.email === 'transferToAccount') {
                  const currentDate = new Date().toString();
                  body = {
                    jobNo: data.data.updateJobCard.jobNo,
                    owner: data.data.updateJobCard.owner,
                    requestedDate: currentDate,
                    id: data.data.updateJobCard.id,
                    type: 'transferToAccount',
                  };
                } else if (action.email === 'Approve') {
                  body = {
                    jobNo: data.data.updateJobCard.jobNo,
                    owner: data.data.updateJobCard.owner,
                    id: data.data.updateJobCard.id,
                    email: data.data.updateJobCard?.ownerEmail,
                    status: 'Approve',
                  };
                } else if (action.email === 'Reject') {
                  body = {
                    jobNo: data.data.updateJobCard.jobNo,
                    owner: data.data.updateJobCard.owner,
                    id: data.data.updateJobCard.id,
                    email: data.data.updateJobCard?.ownerEmail,
                    status: 'Reject',
                  };
                } else if (action.email === 'Revoke') {
                  body = {
                    jobNo: data.data.updateJobCard.jobNo,
                    owner: data.data.updateJobCard.owner,
                    id: data.data.updateJobCard.id,
                    email: data.data.updateJobCard?.ownerEmail,
                    status: 'Revoke',
                  };
                }
                this.http
                  .post(
                    'https://ci9ms1wdj8.execute-api.ap-south-1.amazonaws.com/v1/send',
                    JSON.stringify(body)
                  )
                  .subscribe(
                    (data) => {
                      window.location.reload();
                      return new JobCardUpdated(data);
                    },
                    (error) => {
                      this._snackBar.open(error.message, null, {
                        duration: 5000,
                        horizontalPosition: 'right',
                        verticalPosition: 'top',
                        panelClass: 'custom-snackbar-error',
                      });
                      return new JobCardUpdated(data);
                    }
                  );
              } else {
                window.location.reload();
                return new JobCardUpdated(data);
              }
            } else {
              this.router.navigate(['employee/job-details'], {
                queryParams: {
                  id: data.data.updateJobCard.id,
                },
              });
              this._snackBar.open('Job Updated Successfully', null, {
                duration: 5000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: 'custom-snackbar-success',
              });
              return new JobCardUpdated(data);
            }
          })
        );
      },
      onError: (action: UpdateJObCard, error) => {
        this._snackBar.open(error.errors[0].message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new UpdateJobCardError(error);
      },
    }
  );

  @Effect({ dispatch: false }) saveStuffingDetails = this.actions$.pipe(
    ofType(JobCardActionTypes.SaveStuffingDetails),
    fetch({
      run: (action: SaveStuffingDetails, state: JobCardPartialState) => {
        this.dialog.closeAll();
      },
    })
  );

  @Effect({ dispatch: false })
  saveLoadingConfirmationDetails = this.actions$.pipe(
    ofType(JobCardActionTypes.SaveLoadingConfirmationDetails),
    fetch({
      run: (
        action: SaveLoadingConfirmationDetails,
        state: JobCardPartialState
      ) => {
        this.dialog.closeAll();
      },
    })
  );

  @Effect({ dispatch: false })
  tvtBLDetails = this.actions$.pipe(
    ofType(JobCardActionTypes.SaveTVTBLDetails),
    fetch({
      run: (action: SaveTVTBLDetails, state: JobCardPartialState) => {
        this.dialog.closeAll();
      },
    })
  );

  @Effect({ dispatch: false })
  eglBLDetails = this.actions$.pipe(
    ofType(JobCardActionTypes.SaveEGLBLDetails),
    fetch({
      run: (action: SaveEGLBLDetails, state: JobCardPartialState) => {
        this.dialog.closeAll();
      },
    })
  );

  @Effect()
  saveAWBDetails$ = this.actions$.pipe(
    ofType(JobCardActionTypes.SaveAWBDetails),
    fetch({
      run: (action: SaveAWBDetails, state: JobCardPartialState) => {
        return from(
          API.graphql({
            query: mutations.createAwb,
            variables: {
              input: action.payload,
            },
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          })
        ).pipe(
          map((data: { data }) => {
            this.dialog.closeAll();
            this._snackBar.open('AirwayBill Saved Successfully', null, {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: 'custom-snackbar-success',
            });

            return new UpdateJObCard(
              {
                id: action.id,
                AWBId: data.data.createAwb.id,
              },
              true
            );
          })
        );
      },
      onError: (action: SaveAWBDetails, error) => {
        this._snackBar.open(error.errors[0].message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new SaveAWBDetailsError(error);
      },
    })
  );

  @Effect()
  loadAWBDetails$ = this.actions$.pipe(
    ofType(JobCardActionTypes.LoadAWBDetails),
    fetch({
      run: (action: LoadAWBDetails, state: JobCardPartialState) => {
        return from(
          API.graphql({
            query: queries.getAwb,
            variables: {
              id: action.id,
            },
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          })
        ).pipe(
          map((data: { data }) => {
            return new AWBDetailsLoaded(data.data.getAwb);
          })
        );
      },
      onError: (action: LoadAWBDetails, error) => {
        this._snackBar.open(error.errors[0].message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new LoadAWBDetailsError(error);
      },
    })
  );

  @Effect()
  updateAWBDetails$ = this.actions$.pipe(
    ofType(JobCardActionTypes.UpdateAWBDetails),
    fetch({
      run: (action: UpdateAWBDetails, state: JobCardPartialState) => {
        return from(
          API.graphql({
            query: mutations.updateAwb,
            variables: {
              input: action.payload,
            },
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          })
        ).pipe(
          map((data: { data }) => {
            this.dialog.closeAll();
            this._snackBar.open('AirwayBill Updated Successfully', null, {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: 'custom-snackbar-success',
            });

            return new AWBDetailsUpdated(data.data.updateAwb);
          })
        );
      },
      onError: (action: UpdateAWBDetails, error) => {
        this._snackBar.open(error.errors[0].message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new UpdateAWBDetailsError(error);
      },
    })
  );

  @Effect({ dispatch: false })
  acdDetails = this.actions$.pipe(
    ofType(JobCardActionTypes.SaveACDDetails),
    fetch({
      run: (action: SaveACDDetails, state: JobCardPartialState) => {
        this.dialog.closeAll();
      },
    })
  );

  @Effect() uploadFiles$ = this.actions$.pipe(
    ofType(JobCardActionTypes.UploadFiles),
    fetch({
      run: (action: UploadFiles, state: JobCardPartialState) => {
        return from(
          Storage.put(action.fileName, action.files, {
            progressCallback(progress) {
              new FilesProgress(progress);
            },
          })
        ).pipe(
          map((data) => {
            this._snackBar.open('File Uploaded Successfully', null, {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: 'custom-snackbar-success',
            });
            return new FilesUploaded();
          })
        );
      },
      onError: (action: UploadFiles, error) => {
        this._snackBar.open(error.errors[0].message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new FileUploadError();
      },
    })
  );

  @Effect() loadFiles$ = this.actions$.pipe(
    ofType(JobCardActionTypes.LoadFiles),
    fetch({
      run: (action: LoadFiles, state: JobCardPartialState) => {
        const prefix = `${action.prefix}/`;
        return from(Storage.list(prefix)).pipe(
          map((data) => {
            return new FilesLoaded(data);
          })
        );
      },
      onError: (action: LoadFiles, error) => {
        this._snackBar.open(error.message, null, {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'custom-snackbar-error',
        });
        return new FilesLoadError();
      },
    })
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<
      JobCardPartialState & AuthPartialState
    >,
    private _snackBar: MatSnackBar,
    private router: Router,
    public http: HttpClient,
    public dialog: MatDialog
  ) {}
}
